import React, { Component, Fragment } from 'react';
import { Table } from 'reactstrap';

class Datatable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      availableYears: this.getAvailableYears()
    };
  }

  getAvailableYears() {
    const { currentDistrictsData, columns } = this.props; 
    let availableYears = [];
     
    columns.forEach((item) => {
      for(let yearKey in currentDistrictsData[item.column]) {
        if(availableYears.indexOf(yearKey) === -1 && currentDistrictsData[item.column]) {
          availableYears.push(yearKey); 
        } 
      }  
    });

    return availableYears.sort();
  }

  getRow(title, dataRow) {
    const { availableYears } = this.state;

    if(dataRow) {
      let rows = availableYears.map((year, i) => {
        return <td key={i} className="center-text">{dataRow[year] !== null && dataRow[year] !== undefined ? dataRow[year] : "-"}</td> 
      });

      return (
        <tr key={title}>
          <th scope="row" className="center-text">{title}</th>
          {rows}
        </tr>
      ); 
    } else {
      return null; 
    }
  }

  hasColumns() {
    const { columns, currentDistrictsData } = this.props;
    let hasColumns = false;  

    columns.forEach((item) => {
      if(currentDistrictsData[item.column]) {
        hasColumns = true; 
      }
    });

    return hasColumns;
  }

  splitByNumYears() {
    const { columns, currentDistrictsData } = this.props;
    const singleYearItems = [], multiYearItems = [];

    if(currentDistrictsData) {
      columns.forEach((item) => {
        if(currentDistrictsData[item.column]) {
          const numProperties = Object.keys(currentDistrictsData[item.column]).length;
          if(numProperties > 1) {
            multiYearItems.push(item);
          } else if(numProperties === 1) {
            singleYearItems.push(item);
          }
        }
      });
    }

    return { singleYearItems: this.chunkArray(singleYearItems, 5), multiYearItems: multiYearItems };
  }

  chunkArray(myArray, chunk_size){
    let index = 0;
    const arrayLength = myArray.length;
    const tempArray = [];

    for (index = 0; index < arrayLength; index += chunk_size) {
        const myChunk = myArray.slice(index, index+chunk_size);
        tempArray.push(myChunk);
    }

    return tempArray;
  }

  render() {
    const { title, columns, currentDistrictsData } = this.props; 
    const { availableYears } = this.state;

    if(this.hasColumns()) {
      const { singleYearItems, multiYearItems } = this.splitByNumYears();

      let rows = multiYearItems.map((item) => {
        return this.getRow(item.title, currentDistrictsData[item.column]); 
      }); 

      let headers = availableYears.map((year, i) => {
        return <th key={i} className="center-text">{year}</th>; 
      });
      headers.unshift(<th key="table-title" className="center-text">{title}</th>);

      const singleYearTables = singleYearItems.map((items, i) => {
        const singleHeaders = [], singleValues = [];

        items.forEach((item, i) => {
          const value = currentDistrictsData[item.column];
          for(let key in value) {
            singleHeaders.push(<th key={i} className="center-text">{item.title} ({key})</th>);
            singleValues.push(<td key={i} className="center-text">{value[key]}</td>);
          }
        });

        return (
          <Table bordered key={i}>
            <thead className="bg-secondary text-white">
              <tr>
                {singleHeaders}
              </tr>
            </thead>
            <tbody>
              <tr>
                {singleValues}
              </tr>
            </tbody>
          </Table>
        );
      });

      return (
        <Fragment>
            { multiYearItems.length > 0 && <Table bordered>
              <thead className="bg-secondary text-white">
                <tr>
                  {headers}
                </tr>
              </thead>
              <tbody>
                {rows}
              </tbody>
            </Table> }
           { singleYearItems.length > 0 && singleYearTables }
        </Fragment>
      );
    } else {
      return null; 
    }
  }
}

export default Datatable;
